// Generated via oats. Do NOT modify manually.

import * as t from 'io-ts';
import {excess} from '@fl/cmsch-fe-library';

// @ts-ignore: Workaround for "is declared but its value is never read."
import { PageMetadata, PageMetadataSchema } from 'api/gen/PageMetadata';
// @ts-ignore: Workaround for "is declared but its value is never read."
import { UserProfileSubjectRoleManagementDtoOrganizationRoleManagement, UserProfileSubjectRoleManagementDtoOrganizationRoleManagementSchema } from 'api/gen/UserProfileSubjectRoleManagementDtoOrganizationRoleManagement';

const requiredPart = t.interface({
  content: t.union([t.array(UserProfileSubjectRoleManagementDtoOrganizationRoleManagementSchema), t.null]),
  page: t.union([PageMetadataSchema, t.null]),
});

export const PagedModelUserProfileSubjectRoleManagementDtoOrganizationRoleManagementSchema = excess(requiredPart);

export interface PagedModelUserProfileSubjectRoleManagementDtoOrganizationRoleManagement extends t.TypeOf<typeof PagedModelUserProfileSubjectRoleManagementDtoOrganizationRoleManagementSchema> {}
